import { isDebugEnabled } from '../../../../functions/debugging';
import {
  ChatMessage,
  ChatMessageType,
  ImageContent,
  VideoContent,
  VideoThumbnail,
} from '../models/chatMessage';

const kChatDebug = {
  global: false,
  gateway: true,
  gatewayIO: false,
  messageContext: false,
  settings: false,
  messageAPI: false,
  chatRoom: false,
  msgCountBadge: false,
  sendMsgButton: false,
};

export const isChatDebugEnabled = (name: keyof typeof kChatDebug) =>
  __DEV__ && kChatDebug[name] && isDebugEnabled('chat');

export function isLocalImageContent<T extends ImageContent>(
  content: T,
): content is T & { localFileUri: string } {
  return 'localFileUri' in content;
}

export function isLocalVideoContent<T extends VideoContent>(
  content: T,
): content is T & { localFileUri: string } {
  return 'localFileUri' in content;
}

export function isLocalVideoThumbnail<T extends VideoThumbnail>(
  thumbnail: T,
): thumbnail is T & { localFileUri: string } {
  return 'localFileUri' in thumbnail;
}

export function getMessageThumbnailUrl(msg: ChatMessage) {
  let imageUrl: string | undefined = undefined;

  if (
    msg.type === ChatMessageType.Picture &&
    !isLocalImageContent(msg.content)
  ) {
    imageUrl = msg.content.thumbnailUrl ?? msg.content.imageUrl;
  } else if (
    msg.type === ChatMessageType.Video &&
    !isLocalVideoContent(msg.content) &&
    msg.content.thumbnail != null &&
    !isLocalVideoThumbnail(msg.content.thumbnail)
  ) {
    imageUrl = msg.content.thumbnail.url;
  } else if (msg.type === ChatMessageType.Order) {
    imageUrl = msg.content.imageUrl;
  } else if (msg.type === ChatMessageType.Product) {
    imageUrl = msg.content.imageUrl;
  }

  return imageUrl;
}
